import { injectIntl } from "react-intl";
import { formatNumber } from "src/helpers/formatNumber";

const EngagementMetricCards = ({ metrics }) => {
  return (
    <div className="SmsAnalyticsMetricRow SmsAnalyticsMetricRowCompact">
      <div className="SmsAnalyticsMetricCard">
        <div className="SmsAnalyticsMetricCardTop">
          <div className="SmsAnalyticsMetricLabel">Total Clicks</div>
          <div className="SmsAnalyticsMetricIconPurple">
            <img
              alt=""
              src="/media/icons/link-hyperlink-icon.svg"
              className="w-4 h-4"
            />
          </div>
        </div>
        <div className="flex flex-col gap-2 items-start self-stretch">
          <div className="SmsAnalyticsMetricValue">
            {formatNumber(metrics?.totalClicks)}
          </div>
          <div className="SmsAnalyticsMetricSub">All campaigns</div>
        </div>
      </div>

      <div className="SmsAnalyticsMetricCard">
        <div className="SmsAnalyticsMetricCardTop">
          <div className="SmsAnalyticsMetricLabel">Total Conversions</div>
          <div className="SmsAnalyticsMetricIconPurple">
            <img
              alt=""
              src="/media/icons/check-circle.svg"
              className="w-4 h-4"
            />
          </div>
        </div>
        <div className="flex flex-col gap-2 items-start self-stretch">
          <div className="SmsAnalyticsMetricValue">
            {formatNumber(metrics?.totalConversions)}
          </div>
          <div className="SmsAnalyticsMetricSub">All campaigns</div>
        </div>
      </div>

      <div className="SmsAnalyticsMetricCard">
        <div className="SmsAnalyticsMetricCardTop">
          <div className="SmsAnalyticsMetricLabel">Avg Click-Through Rate</div>
          <div className="SmsAnalyticsMetricIconPurple">
            <img
              alt=""
              src="/media/icons/speedometer.svg"
              className="w-4 h-4"
            />
          </div>
        </div>
        <div className="flex flex-col gap-2 items-start self-stretch">
          <div className="SmsAnalyticsMetricValue">
            {formatNumber(metrics?.CTR)}%
          </div>
          <div className="SmsAnalyticsMetricSub">Clicks / Messages Sent</div>
        </div>
      </div>

      <div className="SmsAnalyticsMetricCard">
        <div className="SmsAnalyticsMetricCardTop">
          <div className="SmsAnalyticsMetricLabel">Conversion Rate</div>
          <div className="SmsAnalyticsMetricIconPurple">
            <img
              alt=""
              src="/media/icons/trend-up-01.svg"
              className="w-4 h-4"
            />
          </div>
        </div>
        <div className="flex flex-col gap-2 items-start self-stretch">
          <div className="SmsAnalyticsMetricValue">
            {formatNumber(metrics?.CR)}%
          </div>
          <div className="SmsAnalyticsMetricSub">Conversions / Clicks</div>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(EngagementMetricCards);
